<template>
	<div class="wuxing-page">
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<div class="logo">
			<img :src="logo" alt="绑定银行卡" />
		</div>

		<div class="content">
			<img :src="contentBgImg" class="contentBgImg" />

			<!-- 输入框区域 -->
			<div class="input-wrapper">
				<!-- 银行卡号输入框 -->
				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						银行卡号：
					</span>
					<input v-model="formData.bankCard" type="text" class="input-field" required placeholder="请输入您的银行卡号">
				</div>

				<!-- 姓名输入框 -->
				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						姓&emsp;&emsp;名：
					</span>
					<input v-model="formData.name" type="text" class="input-field" required placeholder="请输入持卡人姓名">
				</div>

				<!-- 身份证号输入框 -->
				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						身份证号：
					</span>
					<input v-model="formData.idCard" type="text" class="input-field" required placeholder="请输入身份证号码">
				</div>

				<!-- 设置密码输入框 -->
				<div class="input-group">
					<span class="input-label">
						设置密码：
					</span>
					<input v-model="formData.password" type="password" class="input-field"
						:placeholder="hasBankCardInfo ? '留空则不修改密码' : '请输入密码'">
				</div>

				<!-- 确认密码输入框 -->
				<div class="input-group">
					<span class="input-label">
						确认密码：
					</span>
					<input v-model="formData.confirmPassword" type="password" class="input-field"
						:placeholder="hasBankCardInfo ? '留空则不修改密码' : '请再次输入密码'">
				</div>
			</div>

			<!-- 提示信息 -->
			<div class="hint-text">
				请确保您填写的信息真实有效<br />否则将绑定失败
			</div>

			<!-- 绑定按钮 -->
			<div class="bind-btn" @click="handleSubmit">
				{{ hasBankCardInfo ? '修改绑定' : '立即绑定' }}
			</div>
		</div>

		<!-- 成功弹窗 -->
		<van-popup v-model="showSuccessPopup" class="success-popup" :style="{ width: '80%' }"
			:close-on-click-overlay="false" @click="jumpToWithdraw">
			<div class="popup-content">
				<img :src="successImg" class="success-img" alt="绑定成功" />
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import logoImg from '@/assets/withdrawBankCard/logo.png';
	import contentBgImg from '@/assets/withdrawBankCard/bindcard_content_bg_long.png';
	import successImg from '@/assets/withdrawBankCard/bind_success.png';
	import {
		Icon,
		Dialog,
		Popup
	} from 'vant';

	export default {
		name: 'withdrawBindCard',
		components: {
			[Icon.name]: Icon,
			[Popup.name]: Popup
		},
		data() {
			return {
				logo: logoImg,
				contentBgImg: contentBgImg,
				successImg: successImg,
				showSuccessPopup: false,
				loading: false,
				error: null,
				hasBankCardInfo: false, // 是否有银行卡信息
				originalData: null, // 原始数据，用于比较是否有修改
				formData: {
					bankCard: '',
					name: '',
					idCard: '',
					password: '',
					confirmPassword: '',
				},
				// 验证状态
				validationErrors: {
					bankCard: false,
					name: false,
					idCard: false,
				},
				successTimer: null,
				verificationTimer: null
			}
		},
		created() {
			this.$parent.footer('withdrawBankCard', false);
		},
		mounted() {
			// 加载时检查是否已绑定银行卡
			this.loadBankCardInfo();
		},
		beforeDestroy() {
			// 组件销毁时清除定时器
			if (this.verificationTimer) {
				clearTimeout(this.verificationTimer);
				this.verificationTimer = null;
			}
			if (this.successTimer) {
				clearTimeout(this.successTimer);
				this.successTimer = null;
			}
		},
		methods: {
			// 加载银行卡信息
			loadBankCardInfo() {
				Fetch('/user/check_bank_card').then((r) => {
					if (r.code === 1 && r.data) {
						this.hasBankCardInfo = true;
						// 填充表单数据
						this.formData = {
							bankCard: r.data.bank_card || '',
							name: r.data.bank_card_name || '',
							idCard: r.data.id_card || '',
							password: '', // 密码不填充
							confirmPassword: '', // 确认密码不填充
						};
						// 保存原始数据，用于比较是否有修改
						this.originalData = {
							bankCard: r.data.bank_card || '',
							name: r.data.bank_card_name || '',
							idCard: r.data.id_card || ''
						};
					} else {
						// 未绑定银行卡
						this.hasBankCardInfo = false;
						this.originalData = null;
					}
				}).catch(() => {
					console.log('加载银行卡信息失败');
					this.hasBankCardInfo = false;
					this.originalData = null;
				});
			},

			// 检查密码
			checkPassword() {
				// 如果两个密码都不为空，检查是否一致
				if (this.formData.password && this.formData.confirmPassword) {
					if (this.formData.password !== this.formData.confirmPassword) {
						this.$toast({
							message: '两次输入的密码不一致',
						});
						return false;
					}
					// 检查密码长度
					if (this.formData.password.length < 6) {
						this.$toast({
							message: '密码长度不能少于6位',
						});
						return false;
					}
				}

				// 如果一个有值一个为空
				if ((this.formData.password && !this.formData.confirmPassword) ||
					(!this.formData.password && this.formData.confirmPassword)) {
					this.$toast({
						message: '请确认密码',
					});
					return false;
				}

				return true;
			},

			// 检查是否有字段被修改
			hasDataChanged() {
				if (!this.hasBankCardInfo) {
					// 首次绑定，所有字段都需要
					return true;
				}

				// 检查银行卡号、姓名、身份证号是否有修改
				if (this.originalData) {
					const hasBankCardChanged = this.formData.bankCard.replace(/\s/g, '') !== this.originalData.bankCard;
					const hasNameChanged = this.formData.name.trim() !== this.originalData.name;
					const hasIdCardChanged = this.formData.idCard.trim() !== this.originalData.idCard;
					const hasPasswordChanged = !!this.formData.password.trim();
					
					return hasBankCardChanged || hasNameChanged || hasIdCardChanged || hasPasswordChanged;
				}
				
				return true;
			},

			// 表单验证
			validateForm() {
				// 重置验证状态
				this.validationErrors = {
					bankCard: false,
					name: false,
					idCard: false
				};

				let isValid = true;

				// 检查是否有字段被修改
				if (!this.hasDataChanged()) {
					this.$toast({
						message: '未检测到任何修改',
					});
					return false;
				}

				// 银行卡号验证
				if (!this.formData.bankCard || !this.formData.bankCard.trim()) {
					this.validationErrors.bankCard = true;
					this.$toast({
						message: '请输入银行卡号',
					});
					isValid = false;
				}

				// 姓名验证
				if (!this.formData.name || !this.formData.name.trim()) {
					this.validationErrors.name = true;
					this.$toast({
						message: '请输入持卡人姓名',
					});
					isValid = false;
				} else if (!/^[\u4e00-\u9fa5]{2,10}$/.test(this.formData.name.trim())) {
					this.validationErrors.name = true;
					this.$toast({
						message: '请输入正确的姓名',
					});
					isValid = false;
				}

				// 身份证号验证
				if (!this.formData.idCard || !this.formData.idCard.trim()) {
					this.validationErrors.idCard = true;
					this.$toast({
						message: '请输入身份证号',
					});
					isValid = false;
				}

				// 密码验证（只有在修改时不需要强制填写）
				if (!this.hasBankCardInfo) {
					// 首次绑定需要密码
					if (!this.formData.password || !this.formData.password.trim()) {
						this.$toast({
							message: '请输入密码',
						});
						isValid = false;
					} else if (!this.formData.confirmPassword || !this.formData.confirmPassword.trim()) {
						this.$toast({
							message: '请确认密码',
						});
						isValid = false;
					} else if (!this.checkPassword()) {
						isValid = false;
					}
				} else {
					// 已有银行卡信息，密码可选，但如果填写了就要验证
					if (this.formData.password || this.formData.confirmPassword) {
						if (!this.checkPassword()) {
							isValid = false;
						}
					}
				}

				return isValid;
			},

			// 提交银行卡绑定信息
			bindBankCard() {
				const bankCardData = {};
				let hasChanges = false;

				// 检查银行卡号是否有修改
				const currentBankCard = this.formData.bankCard.replace(/\s/g, '');
				if (!this.originalData || currentBankCard !== this.originalData.bankCard) {
					bankCardData.bank_card = currentBankCard;
					hasChanges = true;
				}

				// 检查姓名是否有修改
				const currentName = this.formData.name.trim();
				if (!this.originalData || currentName !== this.originalData.name) {
					bankCardData.name = currentName;
					hasChanges = true;
				}

				// 检查身份证号是否有修改
				const currentIdCard = this.formData.idCard.trim();
				if (!this.originalData || currentIdCard !== this.originalData.idCard) {
					bankCardData.id_card = currentIdCard;
					hasChanges = true;
				}

				// 检查密码是否有修改
				const currentPassword = this.formData.password.trim();
				if (currentPassword) {
					bankCardData.password = currentPassword;
					hasChanges = true;
				}

				// 如果没有修改任何内容
				if (!hasChanges) {
					this.$toast({
						message: '未检测到任何修改',
					});
					return Promise.resolve(false);
				}

				return Fetch('/user/bind_bank_card', bankCardData).then(res => {
					if (res.code === 1) {
						const message = this.hasBankCardInfo ? '银行卡信息修改成功' : '银行卡绑定成功';
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : message,
						});
						// 更新原始数据
						if (this.hasBankCardInfo) {
							this.originalData = {
								bankCard: currentBankCard,
								name: currentName,
								idCard: currentIdCard
							};
						}
						return true;
					} else {
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						return false;
					}
				}).catch(err => {
					this.error = err;
					const message = this.hasBankCardInfo ? '修改失败，请重试' : '绑定失败，请重试';
					this.$toast({
						message: message,
					});
					return false;
				});
			},

			// 显示成功弹窗
			showSuccessPopupFunc() {
				this.showSuccessPopup = true;

				// 设置3秒后自动跳转
				this.successTimer = setTimeout(() => {
					this.jumpToWithdraw();
				}, 3000);
			},

			// 跳转到提现银行卡页面
			jumpToWithdraw() {
				// 清除定时器
				if (this.successTimer) {
					clearTimeout(this.successTimer);
					this.successTimer = null;
				}

				// 关闭弹窗
				this.showSuccessPopup = false;
				
				// 延迟跳转，确保弹窗关闭动画完成
				setTimeout(() => {
					// 跳转到提现银行卡页面
					this.$router.push('/WithdrawBankCard');
				}, 300);
			},

			// 表单提交
			async handleSubmit() {
				// 验证表单
				if (!this.validateForm()) {
					return;
				}

				this.loading = true;

				try {
					// 绑定银行卡
					const bindResult = await this.bindBankCard();
					if (bindResult) {
						// 绑定成功，显示成功弹窗
						this.showSuccessPopupFunc();
					}
				} catch (error) {
					console.error('绑定失败:', error);
				} finally {
					this.loading = false;
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.wuxing-page {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		height: 100vh;
		background-image: url('../../assets/withdrawBankCard/bg.png');
		background-size: cover;
		background-position: center;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #333;
		position: relative;
		overflow: auto;
	}

	.header-bar {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 4.26667vw;
		padding-bottom: 0;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 5vw;
	}

	.logo img {
		height: auto;
		width: 8rem;
		object-fit: contain;
		display: block;
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;
		margin-bottom: 5vw;
	}

	.contentBgImg {
		width: 90%;
		height: auto;
		object-fit: contain;
		display: block;
	}

	/* 输入框区域样式 */
	.input-wrapper {
		width: 80%;
		position: absolute;
		bottom: 23%;
	}

	.input-group {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		padding: 10px;
		border-bottom: 1px solid #ebedf0;
		position: relative;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.95);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

		&:last-child {
			border-bottom: none;
			margin-bottom: 10px;
		}
	}

	.input-label {
		font-size: 14px;
		color: #333;
		font-weight: 500;
		text-align: left;
		position: relative;
		display: flex;
		align-items: center;
		white-space: nowrap;
		width: 100px;
	}

	.required-star {
		color: #ee0a24;
		font-size: 14px;
		margin: 0 5px;
		line-height: 1;
	}

	.input-field {
		flex: 1;
		border: none;
		outline: none;
		font-size: 14px;
		background: transparent;
		color: #333;
		padding: 0;

		&::placeholder {
			color: #969799;
		}
	}

	/* 提示文字样式 */
	.hint-text {
		font-size: 16px;
		font-weight: bold;
		color: #ee0a24;
		text-align: center;
		margin-top: 5px;
		margin-bottom: 20px;
		padding: 0 10px;
		line-height: 1.4;
		font-weight: bold;
		position: absolute;
		bottom: 13%;
	}

	/* 绑定按钮样式 */
	.bind-btn {
		width: 40%;
		padding: 12px 20px;
		background-color: #ff4444;
		/* 红底 */
		border: 2px solid #ffffff;
		/* 白边 */
		border-radius: 25px;
		/* 圆角 */
		color: #ffffff;
		/* 白字 */
		font-size: 16px;
		font-weight: bold;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s ease;
		position: absolute;
		bottom: 5%;
		box-shadow: 0 4px 10px rgba(255, 68, 68, 0.3);

		&:hover {
			background-color: #ff3333;
			transform: translateY(-2px);
			box-shadow: 0 6px 15px rgba(255, 68, 68, 0.4);
		}

		&:active {
			background-color: #ff2222;
			transform: translateY(0);
			box-shadow: 0 2px 5px rgba(255, 68, 68, 0.3);
		}
	}

	/* 成功弹窗样式 */
	.success-popup {
		background: transparent !important;
		border-radius: 8px;
	}

	.success-popup .popup-content {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}

	.success-img {
		width: 100%;
		height: auto;
		object-fit: contain;
	}
</style>